import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "consumer" }

import { ref } from 'vue';
import { InteractiveMap } from '@components/Molecules';
import InteractiveMapLanding from './InteractiveMapLanding.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'InteractiveMapApp',
  props: {
    title: {},
    text: {}
  },
  setup(__props: any) {



const isExploreMap = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!isExploreMap.value)
      ? (_openBlock(), _createBlock(InteractiveMapLanding, {
          key: 0,
          title: _ctx.title,
          text: _ctx.text,
          onSetExploreBtnClicked: _cache[0] || (_cache[0] = (isClicked) => isExploreMap.value = isClicked)
        }, null, 8, ["title", "text"]))
      : _createCommentVNode("", true),
    (isExploreMap.value)
      ? (_openBlock(), _createBlock(_unref(InteractiveMap), {
          key: 1,
          "is-active": isExploreMap.value,
          onCloseExploreMap: _cache[1] || (_cache[1] = ($event: any) => (isExploreMap.value = false))
        }, null, 8, ["is-active"]))
      : _createCommentVNode("", true)
  ]))
}
}

})